export const getCookie = name => {
  const cookieString = document.cookie.split('; ').find(cookie => cookie.startsWith(name));

  if (cookieString) {
    return cookieString.split('=')[1];
  }
  return undefined;
};

export const setCookie = (name, value, days = '') => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires="${date.toGMTString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/; Secure`;
};

export const clearCookie = name => {
  // Set name of cookie with expiry date of one day ago, via https://www.quirksmode.org/js/cookies.html
  setCookie(name, '', -1);
};
